module.exports = __webpack_public_path__ + "static/media/footer-logo.7db3a234.jpg";